'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright (c) 2015-present, Zippy Technologies
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * This source code is licensed under the MIT license found in the
                                                                                                                                                                                                                                                                               * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                               */

var _region = require('@zippytech/region');

var _region2 = _interopRequireDefault(_region);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRegion(region, node) {
  var constrainRegion = void 0;

  if (typeof region === 'function') {
    region = region(node);
  }

  if ((typeof region === 'undefined' ? 'undefined' : _typeof(region)) === 'object') {
    constrainRegion = _region2.default.from(region);
  }

  if (region === true && global.document) {
    var viewportWidth = Math.max(document.documentElement.clientWidth, global.innerWidth || 0);
    var viewportHeight = Math.max(document.documentElement.clientHeight, global.innerHeight || 0);
    constrainRegion = _region2.default.from({
      top: 0,
      left: 0,
      width: viewportWidth,
      height: viewportHeight
    });
  }

  if (!constrainRegion && typeof region === 'string' && global.document) {
    region = document.querySelector(region);
  }

  if (!constrainRegion) {
    constrainRegion = _region2.default.from(region);
  }

  return constrainRegion;
}

exports.default = getRegion;